import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import UploadService from "../../../../services/transaksi/UploadService";
import { formatDateString, getCurrentDateFormatted } from "../../../../utilities/Utils";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaMagnifyingGlass } from "react-icons/fa6";
import * as xlsx from 'xlsx';
import { AsyncPaginate } from "react-select-async-paginate";

const ModalInspeksi = ({ showInspeksi, handleCloseInspeksi, dataDisposisi, dataPrimer, reloadList, isEdit, jenisIzin }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const [listDokInspeksi, setListDokInspeksi] = useState([])
    const [inspeksiDok, setInspeksiDok] = useState([])
    const [dataInspeksi, setDataInspeksi] = useState(null)
    const [hasilInspeksi, setHasilInspeksi] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPrimer?.nomorAju || !dataDisposisi?.noTugas || dataDisposisi.idDisposisi !== 7) {
            return
        }
        try {
            const resInspeksi = await pbumkuService.getUmkuInspeksiDataByAjuAndIdProses(dataPrimer.nomorAju, dataDisposisi.idProses)
            if (resInspeksi.data !== null) {
                setDataInspeksi(resInspeksi.data)
                setValueTglInspeksi(formatDateString(resInspeksi.data.tglInspeksi))
                setValueKomoditas(resInspeksi?.data?.komoditas)
                setValuePeruntukan(resInspeksi?.data?.peruntukanProduk)

                const resJenisSert = await pbumkuService.getJenisSertifikasi(jenisIzin, resInspeksi?.data?.jenisSertifikasi)
                setValueJenisSertOpt(resJenisSert?.data)

                const resInspeksiDok = await pbumkuService.getUmkuInspeksiDataDokByIdInspeksi(resInspeksi.data.idInspeksi)
                setInspeksiDok(resInspeksiDok.data.data)

                const resInspeksiHasil = await pbumkuService.getUmkuHasilInspeksiByAjuAndIdInspeksi(dataPrimer.nomorAju, resInspeksi.data.idInspeksi)
                if (resInspeksiHasil.data !== null) {
                    setHasilInspeksi(resInspeksiHasil?.data)
                    setTotalSesuai(resInspeksiHasil?.data?.totalSesuai)
                    setTotalMinor(resInspeksiHasil?.data?.totalMinor)
                    setTotalMayor(resInspeksiHasil?.data?.totalMayor)
                    setTotalKritis(resInspeksiHasil?.data?.totalKritis)
                    setTotalHasil(resInspeksiHasil?.data?.totalHasil)
                    setKeterangan(resInspeksiHasil?.data?.keterangan)

                }
            }
        } catch (error) {

        }
    }, [pbumkuService, dataDisposisi, dataPrimer, jenisIzin])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                const resDokInspeksi = await pbumkuService.listJenisDokByJenisIzinAndJenisDok(jenisIzin, 'lhp', 0, 20)
                setListDokInspeksi(resDokInspeksi.data.data)

                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };

    }, [pbumkuService, jenisIzin, dataPrimer, fetchAllData])

    const [valueTglInspeksi, setValueTglInspeksi] = useState(getCurrentDateFormatted())
    const onChangeTglInspeksi = e => {
        setValueTglInspeksi(e.target.value)
    }

    const [jsonRawExcel, setJsonRawExcel] = useState(null)
    const [totalSesuai, setTotalSesuai] = useState('')
    const [totalMinor, setTotalMinor] = useState('')
    const [totalMayor, setTotalMayor] = useState('')
    const [totalKritis, setTotalKritis] = useState('')
    const [totalHasil, setTotalHasil] = useState('')
    const [keterangan, setKeterangan] = useState('')
    const [listChecklist, setListChecklist] = useState([])

    const handleChangeInspeksiDok = (id, e) => {
        const file = e.target.files[0]
        if (file) {
            if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                const reader = new FileReader()
                reader.onload = (e) => {
                    const data = e.target.result
                    const workbook = xlsx.read(data, { type: "array" })
                    const sheetname = workbook.SheetNames[0]
                    const worksheet = workbook.Sheets[sheetname]
                    const json = xlsx.utils.sheet_to_json(worksheet, { range: 2 })
                    // console.log(JSON.stringify(json, null))
                    // console.log(json)
                    if (jenisIzin === 'CPIB') {
                        json.map((djson, idx) => {
                            // console.log(djson)
                            if (djson.Persyaratan === 'Jumlah Checklist') {
                                setTotalSesuai(djson.Ketidaksesuaian)
                                setTotalMinor(djson.__EMPTY)
                                setTotalMayor(djson.__EMPTY_1)
                                setTotalKritis(djson.__EMPTY_2)
                            } else if (djson.Persyaratan === 'Nilai Kelulusan') {
                                setKeterangan((Math.round(djson.__EMPTY_3 * 100) / 100) + ' - ' + djson.Ket)
                                setTotalHasil(djson.Ket)
                            } else if (djson.Persyaratan === 'Jumlah Kritis') {
                                // setTotalHasil(djson.Ket)
                            }
                            return djson
                        })
                    } else {
                        let lastJson = json[json.length - 1]
                        // console.log(lastJson)
                        setTotalSesuai(lastJson.Ketidaksesuaian)
                        setTotalMinor(lastJson.__EMPTY)
                        setTotalMayor(lastJson.__EMPTY_1)
                        setTotalKritis(lastJson.__EMPTY_2)
                        setTotalHasil(lastJson.__EMPTY_3)
                    }
                    setJsonRawExcel(JSON.stringify(json, null, null))

                    const tempChecklist = [];
                    json.map((dtljson, idx) => {
                        if (dtljson["Nilai Kuantitatif"] !== undefined && (dtljson["KODE"] || dtljson["Kode"]) !== undefined) {
                            let nilaiChecklist
                            switch (dtljson["Nilai Kuantitatif"]) {
                                case "Sesuai":
                                    nilaiChecklist = 4
                                    break;
                                case "Minor":
                                    nilaiChecklist = 3
                                    break;
                                case "Mayor":
                                    nilaiChecklist = 2
                                    break;
                                case "Kritis":
                                    nilaiChecklist = 0
                                    break;
                                default:
                                    break;
                            }
                            let checklist = {
                                kodeSert: jenisIzin,
                                kodeChecklist: (dtljson["KODE"] || dtljson["Kode"]),
                                nilai: nilaiChecklist,
                                keterangan: (dtljson["Catatan"] || dtljson["Ket"] || dtljson["Keterangan"] || dtljson["CATATAN"]) ?? '-'
                            }
                            tempChecklist.push(checklist)
                        }
                        return dtljson
                    })
                    console.log(tempChecklist)
                    setListChecklist(prev => [...prev, ...tempChecklist])
                }
                reader.readAsArrayBuffer(file)
            }
            setInspeksiDok((prev) => {
                const existing = prev.find((item) => item.idJenisDok === id);
                const newFileName = file.name.replaceAll(" ", "-")
                const renamedFile = new File([file], newFileName, {
                    type: file.type
                })
                if (existing) {
                    return prev.map((item) =>
                        item.idJenisDok === id ? { ...item, dokNameOri: renamedFile.name, dokPath: process.env.REACT_APP_API_URL_FILE + '/view/' + dataPrimer.nomorAju + '/' + renamedFile.name, dokFile: renamedFile } : item
                    );
                } else {
                    return [...prev, { idJenisDok: id, dokNameOri: renamedFile.name, dokPath: process.env.REACT_APP_API_URL_FILE + '/view/' + dataPrimer.nomorAju + '/' + renamedFile.name, dokFile: renamedFile }];
                }
            });
        }
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setListChecklist([])
        setShowProsesSuccess(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        // reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            if (checkKelengkapan()) {
                let noTugas = 'INS-' + dataPrimer.nomorAju
                let jsonInspeksi = {
                    ...dataInspeksi,
                    nomorAju: dataPrimer.nomorAju,
                    noSuratTugas: noTugas,
                    idProses: dataDisposisi.idProses,
                    tglInspeksi: valueTglInspeksi,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date(),
                    jenisSertifikasi: valueJenisSertOpt.jenisSertifikasi
                }
                if (jenisIzin === 'CPIB' || jenisIzin === 'CBIB') {
                    jsonInspeksi = {
                        ...jsonInspeksi,
                        komoditas: valueKomoditas,
                    }
                } else if (jenisIzin === 'CPPIB') {
                    jsonInspeksi = {
                        ...jsonInspeksi,
                        peruntukanProduk: valuePeruntukan,
                    }
                }
                const resSaveInspeksi = await pbumkuService.saveUmkuInspeksiData(jsonInspeksi)
                if (resSaveInspeksi.data.kode === '200') {
                    //ev permohonan dok
                    const idInspeksi = resSaveInspeksi.data.id

                    inspeksiDok.map(async (insDok) => {
                        let newInsDok = {
                            ...insDok,
                            idInspeksi: idInspeksi,
                            nomorAju: dataPrimer.nomorAju,
                            createdBy: localStorage.getItem('userId'),
                            createdDate: new Date()
                        }
                        await pbumkuService.saveUmkuInspeksiDataDok(newInsDok)

                        await uploadService.uploadFile(dataPrimer.nomorAju, insDok.dokFile)
                        // console.log(resUpload)
                    })

                    let dataDispo = {
                        ...dataDisposisi,
                        noTugas: noTugas,
                        tglTugas: new Date()
                    }
                    await pbumkuService.saveUmkuPenugasan(dataDispo)

                    // console.log(jsonRawExcel)

                    let jsonChecklistHasil = {
                        ...hasilInspeksi,
                        idInspeksi: idInspeksi,
                        nomorAju: dataPrimer.nomorAju,
                        totalSesuai: totalSesuai,
                        totalMinor: totalMinor,
                        totalMayor: totalMayor,
                        totalKritis: totalKritis,
                        totalHasil: totalHasil,
                        keterangan: keterangan,
                        createdBy: localStorage.getItem('userId'),
                        createdDate: new Date(),
                        jsonRaw: jsonRawExcel
                    }
                    await pbumkuService.saveUmkuHasilInspeksi(jsonChecklistHasil)

                    listChecklist.map(async (dtCheck) => {
                        let jsonCheck = {
                            ...dtCheck,
                            idInspeksi: idInspeksi,
                            nomorAju: dataPrimer.nomorAju,
                            createdBy: localStorage.getItem('userId'),
                            createdDate: new Date()
                        }
                        await pbumkuService.saveUmkuInspeksiChecklist(jsonCheck)
                    })

                    setShowConfirmProses(false)
                    setShowProsesSuccess(true)
                } else {
                    setShowConfirmProses(false)
                    setShowProsesFailed(true)
                }
            } else {
                setShowConfirmProses(false)
                setShowProsesFailed(true)
            }
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        setListChecklist([])
        handleCloseInspeksi()
    }

    const [base64String, setBase64String] = useState(null)
    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClickPreview = async (dokPath) => {
        setBase64String(dokPath)
        setShowOpenPreview(true)
    }
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}
        if (!valueTglInspeksi) checkKelengkapan.tglInspeksi = 'Tanggal Inspeksi Wajib Diisi'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const [valueJenisSertOpt, setValueJenisSertOpt] = useState(null)
    async function loadOptionJenisSert(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listJenisSertifikasi(jenisIzin, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeJenisSert = e => {
        setValueJenisSertOpt(e)
    }

    const [valueKomoditas, setValueKomoditas] = useState(null)
    const handleChangeKomoditas = e => {
        setValueKomoditas(e.target.value)
    }

    const [valuePeruntukan, setValuePeruntukan] = useState(null)
    const handleChangePeruntukan = e => {
        setValuePeruntukan(e.target.value)
    }

    return (
        <>
            <Modal
                show={showInspeksi}
                onHide={handleCloseInspeksi}
                size='xl'
                centered
            >
                <Modal.Header>
                    <Modal.Title><h5>Inspeksi {jenisIzin}</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPrimer?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi <span className='text-danger'> *</span></Form.Label>
                                    <Col sm="2">
                                        <Form.Control type='date' placeholder="Tanggal Inspeksi" className="form-control-sm" value={valueTglInspeksi} onChange={onChangeTglInspeksi} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.tglInspeksi && <div className="text-danger">{kelengkapan.tglInspeksi}</div>}
                        </div>
                    </div>
                    {
                        (jenisIzin === 'CPIB' || jenisIzin === 'CBIB') &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Komoditas</Form.Label>
                                        <Col sm="8">
                                            <Form.Control type="text" placeholder="Komoditas" className="form-control-sm" value={valueKomoditas} onChange={handleChangeKomoditas} disabled={!isEdit} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    }
                    {
                        jenisIzin === 'CPPIB' &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Peruntukan Produk</Form.Label>
                                        <Col sm="4">
                                            <Form.Control type="text" placeholder="Peruntukan Produk" className="form-control-sm" value={valuePeruntukan} onChange={handleChangePeruntukan} disabled={!isEdit} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    }
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Sertifikasi</Form.Label>
                                    <Col sm="4">
                                        <AsyncPaginate
                                            loadOptions={loadOptionJenisSert}
                                            value={valueJenisSertOpt}
                                            getOptionValue={(option) => option.jenisSertifikasi}
                                            getOptionLabel={(option) => option.jenisSertifikasi + ' - ' + option.uraianSertifikasi}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeJenisSert}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <h6>Dokumen Hasil Inspeksi</h6>
                        </div>
                    </div>
                    {
                        listDokInspeksi &&
                        listDokInspeksi.map((dokwajib, idx) => {
                            const current = inspeksiDok.find((h) => h.idJenisDok === dokwajib.idJenisDok)
                            return (
                                <>
                                    <div className='row' key={dokwajib.idJenisDok || idx}>
                                        <div className='col-12'>
                                            <Form>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">{dokwajib.uraianDok}</Form.Label>
                                                    <Col sm="6">
                                                        {
                                                            current?.dokPath ? <>
                                                                {/* <Form.Label column sm="12" className="control-label align-self-center mb-0" htmlFor="searchNib">{current.dokNameOri}</Form.Label> */}
                                                                <span>{current.dokNameOri}</span>
                                                                <Form.Control type='file' placeholder="file" className="form-control-sm" onChange={e => handleChangeInspeksiDok(dokwajib.idJenisDok, e)} />
                                                            </>
                                                                :
                                                                <Form.Control type='file' placeholder="file" className="form-control-sm" onChange={e => handleChangeInspeksiDok(dokwajib.idJenisDok, e)} />
                                                        }
                                                    </Col>
                                                    <Col sm="2">
                                                        {current?.dokPath && (<Button size='sm' variant='info' onClick={() => handleClickPreview(current.dokPath)} ><FaMagnifyingGlass /> Preview Dok</Button>)}
                                                    </Col>
                                                </Form.Group>
                                            </Form>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Total Ketidaksesuaian</strong></label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-1 col-form-label-sm">Sesuai</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="sesuai" value={totalSesuai} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Minor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="minor" value={totalMinor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Mayor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="mayor" value={totalMayor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Kritis</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="kritis" value={totalKritis} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Hasil / Nilai Kuantitaif</strong></label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="hasil" value={totalHasil} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Keterangan</label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="keterangan" value={keterangan} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && dataPrimer.kodeStatus === '025' && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
            {
                showConfirmProses &&
                <SweetAlert
                    title="Simpan Inspeksi?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    // const pdfUrl = 'data:application/pdf;base64,' + base64string

    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}


export default ModalInspeksi